import sessionInitChats from "../../../core/gd-session/chat/init-chats";
import NavigationSection from "../../../core/model2/navigation/navigation-section";

// const debug = "openChat"
const debug = false

export default async function openChat(navigationSection: NavigationSection, onClickCallback?: callback) {
    if (onClickCallback) onClickCallback()

    if (!gd.session.chatsLoaded) await sessionInitChats()

    // check if defaultAppUrl chat is still available
    let defaultAppUrl
    if (navigationSection.defaultAppUrl) {
        const chatId = _.last(navigationSection.defaultAppUrl.split('/'))
        if (chatId && gd.session.chats.get(chatId)) {
            defaultAppUrl = navigationSection.defaultAppUrl
        }
        // clear defaultAppUrl if chat is not found
        navigationSection.defaultAppUrl = defaultAppUrl
    }

    await gd.layout.navigation.openSectionV2(navigationSection)

    debug && console.log(debug, 'onClick', navigationSection, gd.session.chats)

    // gd.goTo(defaultAppUrl || gd.session.chats.latestUpdatedChat?.url || 'chat') // Etogo ne nado
}
